import $ from 'jquery' // jQuery
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

gsap.registerPlugin(ScrollTrigger)

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  var o = 'expo.out'
  let mm = gsap.matchMedia()
  let scaleFrom
  let txtShowStart
  let txtFadeUp

  mm.add('(max-width: 767px)', () => {
    scaleFrom = '.88'
    txtShowStart = '120'
    txtFadeUp = '-80'
  })

  mm.add('(min-width: 768px)', () => {
    scaleFrom = '.74'
    txtShowStart = '400'
    txtFadeUp = '-40'
  })

  gsap.fromTo(
    '.js-fixMV',
    {
      opacity: '0',
    },
    {
      opacity: '1',
      ease: o,
      scrollTrigger: {
        trigger: '.js-fixMV',
        start: '1200', // 開始位置
        end: '3200', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js_blur',
    {
      opacity: '1',
    },
    {
      opacity: '0',
      duration: 1,
      // y: '-80',
      ease: o,
      scrollTrigger: {
        trigger: '.js_blur',
        start: '20', // 開始位置
        end: '40', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js_MV',
    {
      y: '0',
      scale: scaleFrom,
    },
    {
      y: '-240',
      scale: '1',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js_MV',
        start: '0', // 開始位置
        end: '1000', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js_cover',
    {
      opacity: '0',
    },
    {
      opacity: '0.5',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js_cover',
        start: '0', // 開始位置
        end: '1000', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js_showTxt',
    {
      opacity: '0',
    },
    {
      opacity: '1',
      // yPercent: txtFadeUp,
      yPercent: '-80',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js_showTxt',
        start: txtShowStart, // 開始位置
        // start: '400', // 開始位置
        end: '1000', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js_txtHide',
    {
      opacity: '1',
    },
    {
      opacity: '0',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js_txtHide',
        start: '0', // 開始位置
        end: '1000', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
}

document.addEventListener('DOMContentLoaded', function (e) {
  const tabs = document.querySelectorAll('[data-tab-target]')
  const tabContents = document.querySelectorAll('[data-tab-content]')

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach((tabContent) => {
        tabContent.classList.remove('current')
      })
      tabs.forEach((tab) => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('current')
    })
  })
})

if (document.getElementsByClassName('js__topIntro__video')[0]) {
  if (window.matchMedia('(max-width:768px)').matches) {
    const video = document.getElementsByClassName('js__topIntro__video')[0]
    const VideoImg = document.getElementsByClassName('js_topIntro')[0]
    video.addEventListener(
      'play',
      function () {
        VideoImg.classList.toggle('hide')
      },
      true
    )
  }
}

//FAQ処理
const faqTitle = document.querySelectorAll('.js-qa__title')

for (let i = 0; i < faqTitle.length; i++) {
  faqTitle[i].addEventListener('click', accodionToggle)
}

// 処理
function accodionToggle(e) {
  this.classList.toggle('is-open')
  var panel = this.nextElementSibling
  panel.classList.toggle('is-open')
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null
  } else {
    panel.style.maxHeight = panel.scrollHeight + 'px'
  }
}

//form 必須項目の入力チェック
$(function () {
  function validationForm() {
    var allFilled = true
    $('input.required').each(function () {
      if ($(this).is(':checkbox')) {
        if (!$(this).is(':checked')) {
          allFilled = false
          return false
        }
      } else if (!$(this).val()) {
        allFilled = false
        return false
      }
    })

    $('form input[type="submit"]').prop('disabled', !allFilled)
  }

  $('form').on('change keyup', function () {
    validationForm()
  })

  validationForm()
})
